import { useEffect, useState } from 'react';

import {
	prioritizeSessions,
	type PrioritizedSessions,
	type SessionOrderingItem,
} from './prioritizeSessions';

const MAX_TIMEOUT_MS = 2_147_483_647;

/** Reorders when data changes and exactly when the next promoted session expires. */
export const usePrioritizedSessions = <T>(
	items: readonly SessionOrderingItem<T>[],
): PrioritizedSessions<T> => {
	const [, setClockTick] = useState(0);
	const result = prioritizeSessions(items, Date.now());

	useEffect(() => {
		if (result.nextExpiryAt == null) {
			return;
		}
		const delay = Math.min(MAX_TIMEOUT_MS, Math.max(0, result.nextExpiryAt - Date.now()));
		const timer = window.setTimeout(() => setClockTick((tick) => tick + 1), delay);
		return () => window.clearTimeout(timer);
	}, [result.nextExpiryAt]);

	return result;
};
